module.exports = __webpack_public_path__ + "static/media/mercedes-car.f5a50c12.jpg";